import React, { useState } from 'react';
import { TextField, Autocomplete, InputAdornment } from '@mui/material';
import { SearchOutlined } from '@ant-design/icons';
import "./searchbar.css";

type SearchTerm = {
  value: string;
  section: string;
  value_id: string;
};

type SearchBarProps = {
  searchTerms: SearchTerm[];
  onSearch: (term: string) => void;
};

const SearchBar: React.FC<SearchBarProps> = ({ searchTerms, onSearch }) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [selectedTerm, setSelectedTerm] = useState<SearchTerm | null>(null);

  const handleSearch = () => {
    if (selectedTerm) {
      onSearch(selectedTerm.value);
    } else if (inputValue.trim() !== '') {
      onSearch(inputValue.trim());
    }
  };

  return (
    <div className='search-box-wrapper'>
      <label className='search-box-label' htmlFor="">Subject, user or content</label>
      <Autocomplete
        options={searchTerms}
        getOptionLabel={(option) => option.value}
        value={selectedTerm}
        onChange={(event, newValue) => {
          setSelectedTerm(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder='Type to search...'
            variant="outlined"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();  
                handleSearch();
              }
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined />
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </div>
  );
};

export default SearchBar;
